import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { legalContent } from "../../../assets/Data/legalcomponent";
import Line from "../../../assets/line2.svg";

const LegalContentDisplay = () => {
  const { topic } = useParams();
  const content = legalContent[topic];
  const navigate = useNavigate()

  return (
    <>
      <div className="bg-[#f6f6f7] py-8 px-5 flex flex-col items-center">
        <div className="text-center w-full md:w-[70%] mb-8 mt-2 lg:mt-12">
          <h2 className="text-3xl sm:text-4xl lg:text-[3rem] lg:leading-[3.5rem] font-bold">
            {content.title1}{" "}
            <span className="relative inline-block">
              {content.titleline}
              <img
                src={Line}
                alt="Underline decoration"
                className="absolute bottom-0 left-0 w-full top-9 lg:top-[47px]"
              />
            </span>{" "}
            {content.title2}
          </h2>
          <p className="text-xl md:text-2xl my-6">{content.description}</p>
        </div>
      </div>

      <div className="grid gap-6 py-6 bg-gray-50 sm:grid-cols-2 min-[950px]:grid-cols-3 p-6">
        {content.keyElements.map((card, index) => (
          <div
            key={index}
            className="relative bg-white shadow-lg rounded-lg p-6 flex flex-col justify-between text-left"
            style={{
              backgroundImage: `url(${card.bgImage})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
            }}
          >
            <div className="absolute inset-0 bg-white opacity-5"></div>
            <div className="relative z-10 flex flex-col h-full">
              <div className="flex items-center my-4">
                <div
                  className={`p-4 rounded-lg flex items-center justify-center w-13 h-13 ${card.border} border ${card.bgcolor}`}
                >
                  {card.icon}
                </div>

                <div className="ml-4">
                  <h3 className="text-xl font-bold mb-1">{card.section}</h3>
                </div>
              </div>

              {card.heading.map((heading, i) => (
                <div key={i} className="pl-4">
                  <h3 className="text-lg font-semibold mb-2">{heading}</h3>
                  <p className="text-gray-600 mb-4">{card.details[i]}</p>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>

      <div className="bg-[#f6f6f7] py-8 px-5 flex flex-col items-center">
        <div className="text-center w-full md:w-[70%] mt-2 lg:mt-12">
          <h2 className="text-3xl sm:text-4xl lg:text-[50px] lg:leading-[1.4em] font-bold">
            {content.pretitle1}{" "}
            <span className="relative inline-block">
              {content.pretitleline}
              <img
                src={Line}
                alt="Underline decoration"
                className="absolute bottom-0 left-0 w-full top-9 lg:top-[47px]"
              />
            </span>{" "}
            {content.pretitle2}
          </h2>
          <div className="flex flex-col items-center justify-center pt-5 relative z-10">
            <div className="text-center max-w-4xl px-8 md:px-0">
              <p className="text-xl md:text-2xl my-3">
                At EveryMailFinder.com, we are committed to protecting your
                privacy and ensuring the security of your personal information.
                Below you will find detailed information about our legal
                policies, including our Privacy Policy, Terms of Service, Cookie
                Policy, and compliance with regulations such as GDPR.
              </p>
            </div>
          </div>
          <div className="text-center w-full flex justify-center mt-5 md:mt-10 mb-4">
            <button
              onClick={() => {
                window.scrollTo(0, 0);
                navigate("/pricing");
              }}
              className="text-white hover:bg-[#1C88FC] font-semibold p-3 rounded-md bg-blue-800 hover:text-white w-[220px]"
            >
              View packages
            </button>
          </div>{" "}
        </div>
      </div>
    </>
  );
};

export default LegalContentDisplay;
